export const INVITE_USERS_POST = 'INVITE_USERS_POST'
export const INVITE_USERS_UPDATE = 'INVITE_USERS_UPDATE'
export const INVITE_USERS_ERROR = 'INVITE_USERS_ERROR'
export const INVITE_USERS_LIST_UPDATE = 'INVITE_USERS_LIST_UPDATE'
export const INVITE_USERS_LIST_DELETE = 'INVITE_USERS_LIST_DELETE'

export function postInvitedUsers(payload = {}) {
  return {
    type: INVITE_USERS_POST,
    payload,
  }
}

export function updateInvitedUsers(payload = {}) {
  return {
    type: INVITE_USERS_UPDATE,
    payload,
  }
}

export function errorInvitedUsers(payload = {}) {
  return {
    type: INVITE_USERS_ERROR,
    payload,
  }
}

export function updateInvitedUsersList(payload = {}) {
  return {
    type: INVITE_USERS_LIST_UPDATE,
    payload,
  }
}

export function deleteInvitedUsersList(payload = {}) {
  return {
    type: INVITE_USERS_LIST_DELETE,
    payload,
  }
}
